import React, { createContext, useContext, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const LanguageContext = createContext();

export const LANGUAGES = {
  it: { code: 'it', name: 'Italiano', flag: '\u{1F1EE}\u{1F1F9}', path: '' },
  ru: { code: 'ru', name: 'Русский', flag: '\u{1F1F7}\u{1F1FA}', path: '/ru' }
};

export const DEFAULT_LANGUAGE = 'it';

export function LanguageProvider({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  const language = useMemo(() => {
    if (location.pathname.startsWith('/ru')) {
      return 'ru';
    }
    return 'it';
  }, [location.pathname]);

  const t = (textObj) => {
    if (typeof textObj === 'string') return textObj;
    if (!textObj) return '';
    return textObj[language] || textObj.it || textObj.ru || '';
  };

  const switchLanguage = (newLang) => {
    const currentPath = location.pathname;
    const currentHash = location.hash;
    let newPath;

    if (newLang === 'ru') {
      if (currentPath === '/') {
        newPath = '/ru';
      } else if (!currentPath.startsWith('/ru')) {
        newPath = `/ru${currentPath}`;
      } else {
        newPath = currentPath;
      }
    } else {
      if (currentPath.startsWith('/ru')) {
        newPath = currentPath.replace('/ru', '') || '/';
      } else {
        newPath = currentPath;
      }
    }

    navigate(newPath + currentHash);
  };

  const value = {
    language,
    languages: LANGUAGES,
    t,
    switchLanguage,
    isRussian: language === 'ru',
    isItalian: language === 'it'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}
